import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';

import { ClientDataService } from 'src/app/crm/clients/form/client-form.data';
import { ClientItemEditorView } from './client-item-editor.view';

interface ClientItemEditorControllerProps {
	value: number | null;
	mode: ControlMode;
	onChanged: (value: ClientItem | null) => void;
	setBusy(isBusy: boolean);
	label?: string;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	type?: number;
}

export class ClientItemEditorController extends React.Component<ClientItemEditorControllerProps, any> {
	protected clientDataService: ClientDataService;

	constructor(props) {
		super(props);
		this.clientDataService = ClientDataService.make();
	}

	@autobind
	protected clientQuery(q?: string): Promise<QueryResult<ClientItem>> {
		return new Promise<QueryResult<ClientItem>>((resolve, reject) => {
			this.props.setBusy(true);
			this.clientDataService.searchKeywords = q;
			this.clientDataService.addFilter('isDeleted', 'eq', false);
			if (this.props.type != null) {
				this.clientDataService.addFilter('type', 'eq', this.props.type);
			}
			this.clientDataService.addSorting('id', 'asc', true);
			this.clientDataService.load(query => query)
				.then((items) => {
					this.props.setBusy(false);
					resolve({
						items: items,
						totalCount: this.clientDataService.count
					});
				});
		});
	}

	render() {
		return (
			<ClientItemEditorView
				clientRequest={{ query: this.clientQuery, dataSet: this.clientDataService }}
				onChanged={this.props.onChanged}
				value={this.props.value}
				onGetErrorMessage={this.props.onGetErrorMessage}
				mode={this.props.mode}
				label={this.props.label}
				required={this.props.required}
			>
				{this.props.children}
			</ClientItemEditorView>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/parts/client-item-editor.controller.tsx